import React from "react";
import DropDownQuestion from "./DropDownQuestion";

function NumDropQuestion(props) {
  return (
    <DropDownQuestion
      id={props.id}
      QuestionText={props.QuestionText}
      GuidelineText={props.GuidelineText}
      Choices={Array.from(Array(11).keys())}
      handleValue={props.handleValue}
      Answer={props.Answer}
    ></DropDownQuestion>
  );
}

export default NumDropQuestion;
